import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';

type DeferredActionFactory = () => unknown;

@Injectable({ providedIn: 'root' })
export class DeferredDispatchService {
	private actions: DeferredActionFactory[] = [];
	private readonly store = inject(Store);

	public add(...factories: DeferredActionFactory[]): void {
		this.actions.push(...factories);
	}

	public dispatch(): void {
		this.actions.forEach(factory => {
			this.store.dispatch(factory());
		});
		this.clear();
	}

	private clear(): void {
		this.actions = [];
	}
}
